// extracted by mini-css-extract-plugin
export var root = "Cennik-module--root--X6Rtf";
export var header = "Cennik-module--header--16ZC7";
export var description = "Cennik-module--description--2gnRM";
export var input = "Cennik-module--input--18y-q";
export var pricesList = "Cennik-module--pricesList--3Bu6k";